// import { Icon } from "@iconify/react/dist/iconify.js";
import { Box } from "@mui/material";
import coin from '../../assets/customicons/coin.png';

export default function CoinIcon({ size=20 }) {
    return (
        <span>
        <Box className="centered-container" sx={{
            borderRadius: '50%',
            height: '100%'
        }}>
            <img src={coin} style={{ width: size }} alt="coin icon" />
        </Box>
        </span>
    )
}